import { render, staticRenderFns } from "./add-goal-dialog.vue?vue&type=template&id=005097ad&scoped=true&"
import script from "./add-goal-dialog.vue?vue&type=script&lang=js&"
export * from "./add-goal-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005097ad",
  null
  
)

export default component.exports